import { render, staticRenderFns } from "./PcExpansionPanel.vue?vue&type=template&id=0c1f3842"
import script from "./PcExpansionPanel.vue?vue&type=script&lang=js"
export * from "./PcExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./PcExpansionPanel.vue?vue&type=style&index=0&id=0c1f3842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
